<template>
  <aside v-if="collection && collection.item_count" class="collection-dock" aria-live="polite">
    <div>
      <strong>{{ collection.title || 'Saved highlights' }}</strong>
      <span>
        {{ collection.item_count }} moment{{ collection.item_count === 1 ? '' : 's' }} ·
        {{ collection.ceremony_count }} ceremon{{ collection.ceremony_count === 1 ? 'y' : 'ies' }}
      </span>
    </div>
    <div class="dock-actions">
      <button type="button" class="change-button" @click="$emit('change')">Change</button>
      <button type="button" @click="$emit('review')">Review</button>
    </div>
  </aside>
</template>

<script>
export default {
  name: 'CeremonyCollectionDock',
  props: {
    collection: {
      type: Object,
      default: null,
    },
  },
}
</script>

<style scoped>
.collection-dock {
  position: sticky;
  z-index: 20;
  bottom: 18px;
  display: flex;
  width: min(100%, 620px);
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  margin: 28px auto 0;
  padding: 12px 12px 12px 18px;
  border: 1px solid #d8d0f4;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.97);
  box-shadow: 0 18px 45px rgba(44, 29, 79, 0.16);
  backdrop-filter: blur(12px);
}

.collection-dock div {
  display: grid;
  gap: 2px;
}

.collection-dock > div:first-child {
  min-width: 0;
}

.collection-dock .dock-actions {
  display: flex;
  flex: none;
  align-items: center;
  gap: 7px;
}

.collection-dock strong {
  overflow: hidden;
  color: #252033;
  font-size: 0.86rem;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.collection-dock span {
  color: #777185;
  font-size: 0.74rem;
}

.collection-dock button {
  min-height: 44px;
  padding: 0 17px;
  border: 1px solid #6d28d9;
  border-radius: 10px;
  background: #6d28d9;
  color: #fff;
  font-size: 0.78rem;
  font-weight: 720;
  cursor: pointer;
}

.collection-dock .change-button {
  border-color: transparent;
  background: transparent;
  color: #5f5671;
}

.collection-dock button:hover {
  background: #5b21b6;
}

.collection-dock .change-button:hover {
  background: #f4f1fb;
}

.collection-dock button:focus-visible {
  outline: 3px solid rgba(109, 40, 217, 0.25);
  outline-offset: 2px;
}

@media (max-width: 640px) {
  .collection-dock {
    bottom: max(10px, env(safe-area-inset-bottom));
    gap: 12px;
    margin-top: 20px;
    padding: 10px 10px 10px 14px;
    border-radius: 14px;
  }

  .collection-dock button {
    padding: 0 13px;
  }
}
</style>
